// เรียงรายการเบิกของแท็บ "วันนี้" ฝั่งหน้าเว็บ (ทับลำดับที่ backend เรียงมาอีกชั้น) — ใช้ร่วมกันระหว่าง
// ExpensesTabToday.js (/finance/expenses) กับ Profile expenseQueue (/profile/payment-approval,
// /profile/expense-review) ให้ลำดับตรงกันเป๊ะ ห้ามแยกแก้ที่ใดที่หนึ่ง
export const STATUS_GROUP_ORDER = {
  PENDING: 0,
  PREAPPROVE: 0,
  APPROVE_1: 0,
  APPROVE_2: 0,
  APPROVE: 1,
  PREPARE: 2,
  SUCCESS: 3,
};

// คืน array ใหม่ (ไม่แก้ rows เดิม)
// sortBy 'status' จัดกลุ่มตาม STATUS_GROUP_ORDER — ตัวเลือกอื่น (createdAt/date/amount/success_date)
// เรียงจากฟิลด์นั้นๆ ตรงๆ แทน
export function sortTodayExpenses(rows, sortBy, sortDir) {
  const sorted = [...rows];
  if (sortBy === 'status') {
    // เหมือน _statusGroup/_statusPriority ฝั่ง backend (expenses.service.js) — เรียงกลุ่ม (อยู่ใน flow
    // อนุมัติปกติ หรือหลุด flow ไปแล้วอย่าง REJECT/CANCEL/HOLD) ก่อนเสมอไม่ขึ้นกับ sortDir กัน REJECT/CANCEL
    // สลับขึ้นไปอยู่บนสุดตอนเลือก "สถานะ: สำเร็จก่อน" — sortDir มีผลแค่ลำดับภายในกลุ่ม flow ปกติ (0-3)
    const dirMultiplier = sortDir === 'asc' ? 1 : -1;
    return sorted.sort((a, b) => {
      const groupA = STATUS_GROUP_ORDER[a.status] === undefined ? 1 : 0;
      const groupB = STATUS_GROUP_ORDER[b.status] === undefined ? 1 : 0;
      if (groupA !== groupB) return groupA - groupB;
      const priorityDiff = dirMultiplier * ((STATUS_GROUP_ORDER[a.status] ?? 0) - (STATUS_GROUP_ORDER[b.status] ?? 0));
      if (priorityDiff !== 0) return priorityDiff;
      return new Date(a.createdAt) - new Date(b.createdAt);
    });
  }
  const dir = sortDir === 'asc' ? 1 : -1;
  if (sortBy === 'amount') {
    // ยอดจ่ายจริง — สูตรเดียวกับที่โชว์ในการ์ด "ยอดจ่ายจริง" (ExpensesTableApplove.js) net_price
    // ถ้ามี/>0 ไม่งั้น fallback price - withholding_tax เหมือนกับฝั่ง backend (expenses.service.js)
    const amountOf = (row) => (
      row?.net_price > 0 ? row.net_price : (Number(row?.price) || 0) - (Number(row?.withholding_tax) || 0)
    );
    return sorted.sort((a, b) => dir * (amountOf(a) - amountOf(b)));
  }
  if (sortBy === 'success_date') {
    // วันที่สถานะเปลี่ยนเป็น SUCCESS จริง — หา approval_logs entry ล่าสุดที่ status==='SUCCESS'
    // (เหมือน latestApprovalLog ฝั่ง paymentApproval/ExpenseRow.js) ต่างจาก sortBy:'date' ที่เป็น
    // แค่ฟิลด์วันที่กรอกตอนตั้งเบิก — ให้ผลตรงกับฝั่ง backend (expenses.service.js createPipeline)
    const successAt = (row) => {
      const log = [...(row?.approval_logs || [])].reverse().find((l) => l.status === 'SUCCESS');
      return log?.acted_at ? new Date(log.acted_at) : null;
    };
    return sorted.sort((a, b) => dir * ((successAt(a) || 0) - (successAt(b) || 0)));
  }
  const field = sortBy === 'date' ? 'date' : 'createdAt';
  return sorted.sort((a, b) => dir * (new Date(a[field]) - new Date(b[field])));
}
